/**
 * Shared horizontal scroller controls for NC product sliders.
 * Uses event delegation so it still works after Shopify
 * product-recommendations replaces innerHTML asynchronously.
 */
(function () {
  function getScrollerFromButton(button) {
    const section =
      button.closest('[data-nc-slider]') ||
      button.closest('.nc-product-slider') ||
      button.closest('.nc-pdp-related') ||
      button.closest('.shopify-section');

    if (!section) return null;

    return (
      section.querySelector('[data-nc-slider-scroller]') ||
      section.querySelector('[data-nc-related-scroller]') ||
      section.querySelector('.nc-product-slider__grid')
    );
  }

  function getScrollAmount(scroller) {
    const styles = window.getComputedStyle(scroller);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const card = scroller.querySelector('.nc-product-card');

    if (!card) {
      return Math.max(240, Math.round(scroller.clientWidth * 0.9));
    }

    const cardWidth = card.getBoundingClientRect().width;
    const step = cardWidth + gap;

    // Peek layout (e.g. mobile ~78vw): advance one card.
    // Full-fit layout: page by the visible set.
    if (cardWidth > scroller.clientWidth * 0.55) {
      return Math.round(step);
    }

    return Math.round(scroller.clientWidth + gap);
  }

  document.addEventListener('click', function (event) {
    const button =
      event.target.closest('[data-nc-slider-arrows] button[data-dir]') ||
      event.target.closest('[data-nc-related-arrows] button[data-dir]') ||
      event.target.closest('.nc-arrows-navigation button[data-dir]');

    if (!button) return;

    const scroller = getScrollerFromButton(button);
    if (!scroller) return;

    event.preventDefault();
    const dir = button.getAttribute('data-dir') === 'next' ? 1 : -1;
    scroller.scrollBy({ left: dir * getScrollAmount(scroller), behavior: 'smooth' });
  });
})();
